import { isMultiSelectFilter, isLinkFilter } from '@as-react/common-utils';
import { LOCATION_CHANGE } from 'connected-react-router';
import { FilterActionTypes, UrlActionTypes } from '../../../enums/ActionEnums';
import { ContentOverviewActionTypes } from '../types/ContentActionTypes';
export const initialContentState = {};
const updateFiltersState = (filters, action) => {
    const filterKeys = action.payload.filteredItems.map((item) => item.filterKey);
    return filters.map((filter) => {
        if (filter.filterOn === action.payload.filterOn) {
            return Object.assign(Object.assign({}, filter), { values: filter.values.map((filterValue) => {
                    let isActive = filterValue.active;
                    const filterIndex = filterKeys.indexOf(filterValue.filterKey);
                    if (isMultiSelectFilter(action.payload)) {
                        isActive = filterIndex !== -1 ? !isActive : isActive;
                    }
                    else if (isLinkFilter(action.payload)) {
                        isActive = filterIndex !== -1 ? !isActive : false;
                    }
                    return Object.assign(Object.assign({}, filterValue), { active: isActive });
                }) });
        }
        return Object.assign({}, filter);
    });
};
const removeAllFilters = (filters) => filters.map((filter) => (Object.assign(Object.assign({}, filter), { values: filter.values.map((filterValueObject) => (Object.assign(Object.assign({}, filterValueObject), { active: false }))) })));
export const loadContentReducer = (initialData = {}) => {
    const initialState = Object.assign(Object.assign({}, initialContentState), initialData);
    return (state = initialState, action) => {
        switch (action.type) {
            case LOCATION_CHANGE:
                return action.payload.location && action.payload.location.state
                    ? Object.assign({}, action.payload.location.state.content) : state;
            case UrlActionTypes.UPDATE_FILTERS:
                return Object.assign(Object.assign({}, state), { filters: updateFiltersState(state.filters, action) });
            case FilterActionTypes.REMOVE_ALL_FILTERS:
                return Object.assign(Object.assign({}, state), { filters: removeAllFilters(state.filters) });
            case UrlActionTypes.UPDATE_PAGE:
                return Object.assign(Object.assign({}, state), { isLoading: true });
            case ContentOverviewActionTypes.SHOW_PLACEHOLDER_TILES:
                return Object.assign(Object.assign({}, state), { isLoading: true });
            case ContentOverviewActionTypes.UPDATE_CONTENT:
                return Object.assign(Object.assign({}, state), { tiles: Object.assign({}, action.payload), isLoading: false });
            case ContentOverviewActionTypes.UPDATE_FILTERS:
                return Object.assign(Object.assign({}, state), { filters: [...action.payload] });
            default:
                return state;
        }
    };
};
export const ContentReducer = loadContentReducer();
